"use client";
import { BrandModel } from "@/types/brand";
import React from "react";
import CarouselSection from "../ui/carousel-section";
import { Card, CardContent } from "../ui/card";
import Image from "next/image";
import ClientLink from "../ui/client-link";
import { cn } from "@/lib/utils";

const BrandsCarouselFilters = ({
  brands,
  option,
  category,
  subcategory,
}: {
  brands: BrandModel[] | undefined;
  option: string;
  category?: string;
  subcategory?: string;
}) => {
  return (
    <CarouselSection
      items={brands ?? []}
      renderItem={(brand) => {
        const isActive = brand.id.toString() === option;
        const href = isActive
          ? `/categories/${category}?subcategory=${subcategory}`
          : `/categories/${category}?subcategory=${subcategory}&option=${brand.id}`;
        return (
          <ClientLink href={href} scroll={false}>
            <Card
              className={cn(
                "flex justify-center min-h-[65px] shadow-none py-3 transition-all duration-300  hover:!border-primary",
                isActive ? "border-primary bg-primary/5" : "",
              )}
            >
              <CardContent className="flex items-center gap-3 px-3">
                <Image
                  src={brand.logo_url}
                  alt={brand.name}
                  width={40}
                  height={40}
                  className="rounded-full"
                />
                <h2>{brand.name}</h2>
              </CardContent>
            </Card>
          </ClientLink>
        );
      }}
      breakpoints={{
        lg: "lg:basis-1/6",
        md: "md:basis-1/4",
        sm: "sm:basis-1/3",
        base: "basis-[50%]",
      }}
      displayArrows={false}
    />
  );
};

export default BrandsCarouselFilters;
